import {BehaviorSubject} from 'rxjs';

export const resetSecurityType$ = new BehaviorSubject(createInitResetSecurityType());
export const answerStatus$ = new BehaviorSubject(0);

function createInitResetSecurityType() {
  return {
    balanceType: 0,
    resetRecordId: 0,
    resetRecordStatus: 0,
    remainCount: 0,
    code: 0,
    advancedKycPassed: false,
  };
}
